import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { RouterProps, useLocation } from 'react-router';
import withModal from '@lwtears/lwt-common-frontend/lib/Modal/withModal';
import { UseModalDispatch } from '@lwtears/lwt-common-frontend/lib/Modal';
import { createEvent } from 'api/telemetry';
import withStyles from 'components/@layout/withStyles';
import ResourceModal from 'components/@common/Modals/ResourcePlayer';
import { selectResource, toggleResourcePlayerVisibility } from 'state/modules/app';
import { FONT_GSS_FUTURA } from 'themes/default';
import { AppStoreState, LiteResource, RESOURCE_TYPES } from 'types';
import { parseQueryParams } from 'util/query-params-util';
import SupportVideoTile from './SupportVideoTile';

type Props = {
  classes: any;
  selectedResource: LiteResource;
  selectResource: (resource: LiteResource) => void;
  openDraggableModal: (prop: any) => void;
  toggleResourcePlayerVisibility: (show: boolean) => void;
  supportResources: any;
} & RouterProps &
  UseModalDispatch;

const SupportVideos = (props: Props) => {
  const location = useLocation();

  const createTelemetryEvent = (resource: LiteResource) =>
    createEvent('accessResource', {
      section: 'resources',
      resourceId: resource.id,
      resourceType: resource.type.type
    });
  const handleSelectResource = async (resource: LiteResource) => {
    await props.selectResource(resource);
    props.toggleResourcePlayerVisibility(true);
    openResourceModal(resource);
  };

  const openResourceModal = (selectedResource): void => {
    props.openDraggableModal({
      Title: () => <div />,
      titleText: selectedResource.title,
      body: (
        <ResourceModal
          selectedResource={selectedResource}
          frameType={RESOURCE_TYPES.AV_PLAYER}
          handleClose={props.closeModal}
          eventLogger={() => createTelemetryEvent(selectedResource)}
        />
      ),
      options: { closeOnBackdropClick: true }
    });
  };

  const {
    classes: { headerText, gridLayout }
  } = props;

  const queryParams: any = parseQueryParams(location.search) ?? {
    active: props?.supportResources ? Object.keys(props?.supportResources)?.[0] : ''
  };

  return (
    <div style={{ width: 'fit-content' }}>
      <div className={headerText}> {queryParams?.active}</div>

      <ul className={gridLayout}>
        {props.supportResources?.[queryParams?.active]?.map((resource, index) => (
          <li key={index}>
            <SupportVideoTile
              title={resource.title}
              onClick={() => handleSelectResource(resource)}
            />
          </li>
        )) ?? null}
      </ul>
    </div>
  );
};
const styles: any = {
  gridLayout: {
    display: 'grid',
    gridAutoFlow: 'row',
    gridGap: '20px 20px',
    justifyContent: 'center',
    listStyle: 'none',
    gridTemplateColumns: '1fr 1fr 1fr'
  },
  headerText: {
    marginLeft: 50,
    marginTop: 40,
    marginBottom: 15,
    fontFamily: FONT_GSS_FUTURA,
    fontSize: '32px',
    fontWeight: 600
  }
};
const mapStateToProps = (state: AppStoreState) => {
  return {
    selectedResource: state.app.resource.selectedResource,
    supportResources: state.entity.supportResources
  };
};
export default compose(
  withModal,
  withStyles(styles),
  connect(mapStateToProps, {
    selectResource,
    toggleResourcePlayerVisibility
  })
)(SupportVideos) as any;
